import axios from 'axios';
import { supabase } from './supabase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const API_BASE = API;

export const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach current user email + role as headers so backend can log + enforce permissions
api.interceptors.request.use(async (config) => {
  try {
    const { data } = await supabase.auth.getSession();
    if (data?.session?.user?.email) {
      const email = data.session.user.email;
      config.headers['X-User'] = email;
      let role = data.session.user.user_metadata?.role || 'admin';
      // Roster-based role: if the email is in the analyst list cached below, override.
      // Best-effort lookup; if it fails we keep the metadata role.
      const rosterKey = 'wolf_analyst_emails';
      try {
        const cached = JSON.parse(localStorage.getItem(rosterKey) || '[]');
        if (!data.session.user.user_metadata?.role && cached.includes(email.toLowerCase())) role = 'analyst';
      } catch (e) { /* noop */ }
      config.headers['X-Role'] = role;
    }
  } catch (e) {
    // ignore - works without
  }
  return config;
});

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const calculateInvoiceTotal = (invoice) => {
  if (!invoice || !invoice.items) return { subtotal: 0, gst: 0, tds: 0, total: 0 };

  const subtotal = invoice.items.reduce((sum, item) => sum + (parseFloat(item.amt) || 0), 0);
  const gst = subtotal * (parseFloat(invoice.gst_percent) || 0) / 100;
  const tds = subtotal * (parseFloat(invoice.tds_percent) || 0) / 100;
  const total = subtotal + gst - tds;

  return { subtotal, gst, tds, total };
};
